import { View } from "@-/com.npmjs.react-native";
import { Button } from "@-/dev.improve.haniverse.components.ui.button";
import { Text } from "@-/dev.improve.haniverse.components.ui.text";
import { PrimaryControlsStripTitle } from "@-/dev.improve.haniverse.routes.nav._components.primary-controls-strip.title";
import { useLearnSummaryPageNavigator } from "@-/dev.improve.haniverse.routes.nav.app.learn.summary.navigator";

/**
 * The deck route was opened with params that don't describe a card (a stale or hand-edited deep
 * link) and no deck session owns it. Covers the deck's area like an active session would, and
 * offers the way out every Learn dead end uses: replacing the route with the Learn summary.
 */
export function LearnDeckEntryNotFound() {
  const summaryPageNavigator = useLearnSummaryPageNavigator();

  return (
    <View
      className="absolute inset-0 z-10 items-center justify-center gap-4 bg-muted px-6"
      testID="learn-deck-entry-not-found"
    >
      <PrimaryControlsStripTitle>Learn</PrimaryControlsStripTitle>
      <View className="max-w-sm items-center gap-2">
        <Text className="text-center text-xl font-semibold text-foreground">
          Couldn&apos;t open this card
        </Text>
        <Text className="text-center text-base text-muted-foreground">
          This link doesn&apos;t point to a card. It may be incomplete or out of date.
        </Text>
      </View>
      <Button
        className="mt-2"
        disabled={summaryPageNavigator.replace.isPending}
        onPress={() => {
          summaryPageNavigator.replace.mutate();
        }}
        testID="learn-deck-entry-not-found-go-to-learn"
        variant="outline"
      >
        <Text>Go to Learn</Text>
      </Button>
    </View>
  );
}
